export type JsmRequestSelectFieldValueDto = Record<'id', string>;

export type JsmRequestFieldDto = {
  id: string;
  value: string | string[] | JsmRequestSelectFieldValueDto | JsmRequestSelectFieldValueDto[];
};

export type JsmRequestDto = {
  fields: JsmRequestFieldDto[];
};

export type JsmResponseFriendlyReasonDto = {
  title: string;
  body: string;
};

export const JsmGenericFriendlyReason: JsmResponseFriendlyReasonDto = {
  title: 'Generic error',
  body: 'An error has occurred. Please excuse the inconvenience.',
};

export type JsmErrorResponseDto = {
  friendlyReason: JsmResponseFriendlyReasonDto;
  technicalReason: string | null;
};
